import Tax from '@/dto/taxes/Tax'
import Country from '@/dto/deliveries/Country'

export default function TaxFactory(): Tax {
  return {
    id: null,
    currencyCode: null,
    options: [],
    fromCountryId: null,
    toCountryId: null,
    fromCountry: {} as Country,
    toCountry: {} as Country,
  }
}
